import React from 'react'
import styled from 'styled-components';

const Work = ({ data }) => {
    return (
        <Card>
            <div className="card__image">
                <img src={data.image} alt="image" />
            </div>
            <div className="card__details">
                <h4>{data.name}</h4>
                <p>{data.description}</p>
                <a href={data.link} target="_blank">View</a>
            </div>
        </Card>
    )
}

export default Work

const Card = styled.div`
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    /* justify-content: flex-end; */
    margin: 1rem;
    /* padding: 1.5rem; */
    height: 15rem;
    width: 20rem;
    position: relative;
    background: red;
    transition: all 0.4s ease;
    .card__details{
        z-index: 4;
        height: 100%;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        transition: all 0.4s ease;
        h4{
            font-size: 1.5rem;
            color: #fff;
        }
        p{
            color: #fff
        }
        a{
            text-decoration: none;
            color: white;
            background: #e21f36;
            padding: 0.3rem 1rem;
            font-size: 1.3rem;
            border: none;
            border-radius: 0.4rem;
            display: none;
            transition: all 0.4s ease;
            &:hover{
                background: orangered;
            }
        }
    }
    .card__image{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 2;
        background: #1b1b1b;
        transition: all 0.4s ease;
        img{
            width: 100%;
            height: 100%;
            object-fit: cover;
            opacity: 0.6;
            transition: all 0.4s ease;
        }
    }
    &:hover{
        img{
            opacity:0.3;
            transition: 0.3s ease;
        }
        a{
            display: flex;
            transition: all 0.4s ease;
        }
    }
`
